<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <query-form
            class="content_block"
            label-width="110px"
            size="small"
            label-position="right"
            @search="handleSearch('init')"
            @reset="handleReset"
            :keepOpenedRow="2">
            <el-form-item label="对账状态" :span="24">
              <check-tag v-model="JZForm.reconciliaState" @change="() => handleSearch()">
                <check-tag-item
                  :value="i.value"
                  :key="i.value"
                  v-for="i in executionStatusGroup"
                  :label="`${i.title}(${i.count || 0})`"
                ></check-tag-item>
              </check-tag>
            </el-form-item>
            <el-form-item label="对账单编号" :span='6'>
              <el-input
                v-model.trim="JZForm.prCode"
                clearable
                placeholder="请输入对账单编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="付款方式" :span='6'>
              <el-select
                v-model.trim="JZForm.paymentWay"
                clearable
                @change="handleSearch"
                placeholder="请选择付款方式"
              >
                <el-option
                  v-for="item in payWayOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="核销状态" :span='6'>
              <el-select
                v-model.trim="JZForm.writeOffState"
                clearable
                @change="handleSearch"
                placeholder="请选择收款状态"
              >
                <el-option
                  v-for="item in writeOffStateOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户抬头" :span='6'>
              <el-input
                v-model.trim="JZForm.unitName"
                clearable
                placeholder="请输入客户抬头"
              ></el-input>
            </el-form-item>
            <el-form-item label="开票状态" :span='6'>
              <el-select
                v-model.trim="JZForm.opentTicketState"
                clearable
                @change="handleSearch"
                placeholder="请选择开票状态"
              >
                <el-option
                  v-for="item in billingStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="入票状态" :span='6'>
              <el-select
                v-model.trim="JZForm.inTicketState"
                clearable
                @change="handleSearch"
                placeholder="请选择入票状态"
              >
                <el-option
                  v-for="item in ticketEntryStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="对账开始日期" :span='6'>
              <el-date-picker
                v-model="JZForm.reconciliaStart"
                type="date"
                @change="handleSearch"
                value-format='yyyy-MM-dd'
                placeholder="请选择对账开始日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="对账结束日期" :span='6'>
              <el-date-picker
                v-model="JZForm.reconciliaEnd"
                type="date"
                @change="handleSearch"
                value-format='yyyy-MM-dd'
                placeholder="请选择对账结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="付款申请金额" :span='6' class="amountInfo">
              <el-select
                v-model.trim="JZForm.mark"
                clearable
                placeholder="请选择"
                @change="handleSearch"
                style="width:140px;margin-right:10px;"
              >
                <el-option
                  v-for="item in unitOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input-number v-model.trim="JZForm.payRefundAmount" :precision="2" :step="1" :min="0" placeholder="请输入付款申请金额"></el-input-number>
            </el-form-item>
          </query-form>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnList"
            :data="dataList"
            :toolsAttrs="toolsAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            rowKey="id"
            @refresh="handleReset"
            @fullScreen="handleFullScreen">
            <template #custom>
              <tableHeaderConfiguration businessType="accountStatements" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
            <template slot="tdAction" slot-scope="prCode, row">
              <span v-if="$withPermission('gongxutong:reconciliation_settlement:statement:detail')" @click="() => handleDetail(row)" style="color: #5195eb;cursor: pointer;">{{ prCode || '--' }}</span>
            </template>
            <div slot="action" slot-scope="_, row">
              <a v-if="row.reconciliaState === 'wait' && $withPermission('gongxutong:reconciliation_settlement:statement:audit')" style="margin-left: 8px" @click="() => handleEnsure(row)">确认</a>
            </div>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="pagination.pageNum"
        :total="total"
        :show-total="total => `共 ${total || 0} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="pagination.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>
<script>
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';
import { queryStateInfo, queryReconciliationList } from '@/api/accountStatement';
import {
  collectionStatusOptions,
  deliveryStatusOptions,
  changeStatusOptions,
} from '@/model/saleContract';

import * as Moment from 'dayjs';

const COMMON_COLUMN = [
  {
    ellipsis: true,
    title: '对账单编号',
    width: 180,
    dataIndex: 'prCode',
    key: 'prCode',
    scopedSlots: { customRender: 'tdAction' },
  },
  {
    title: '客户抬头',
    dataIndex: 'unitName',
    key: 'unitName',
    width: 180,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '对账区间',
    width: 210,
    dataIndex: 'reconciliaStart',
    key: 'reconciliaStart',
    customRender: (text, row) => {
      return `${row.reconciliaStart} - ${row.reconciliaEnd}`;
    },
  },
  {
    ellipsis: true,
    title: '对账状态',
    width: 110,
    dataIndex: 'reconciliaState',
    key: 'reconciliaState',
    customRender: text => {
      let statusStr = {
        'wait': '待确认',
        'reject': '已驳回',
        'run': '结算中',
        'already': '已完成',
      }[text] || '--';
      return statusStr;
    },
  },
  {
    ellipsis: true,
    title: '对账金额(元)',
    width: 110,
    dataIndex: 'reconciliaAmount',
    key: 'reconciliaAmount',
    customRender: text => {
      return text === '' || text === null || text === undefined ? '--' : text.toLocaleString('en-US', { minimumFractionDigits: 2});
    },
  },
  {
    ellipsis: true,
    title: '对账数量',
    width: 110,
    dataIndex: 'reconciliaNum',
    key: 'reconciliaNum',
    customRender: text => {
      return text === '' || text === null || text === undefined ? '--' : text;
    },
  },
  {
    ellipsis: true,
    title: '付款方式',
    width: 110,
    dataIndex: 'paymentWay',
    key: 'paymentWay',
    customRender: text => {
      let statusStr = {
        'AP': '账期付款',
        'AC': '预付款',
      }[text] || '--';
      return statusStr;
    },
  },
  {
    ellipsis: true,
    title: '开票状态',
    width: 110,
    dataIndex: 'opentTicketState',
    key: 'opentTicketState',
    customRender: text => {
      let statusStr = {
        'wait': '待开票',
        'part': '部分开票',
        'already': '已完成',
      }[text] || '--';
      return statusStr;
    },
  },
  {
    ellipsis: true,
    title: '入票状态',
    width: 110,
    dataIndex: 'inTicketState',
    key: 'inTicketState',
    customRender: text => {
      let statusStr = {
        'wait': '待入票',
        'part': '部分入票',
        'already': '已入票',
      }[text] || '--';
      return statusStr;
    },
  },
  {
    ellipsis: true,
    title: '核销状态',
    width: 110,
    dataIndex: 'writeOffState',
    key: 'writeOffState',
    customRender: text => {
      let statusStr = {
        'wait': '待核销',
        'part': '部分核销',
        'already': '已核销',
      }[text] || '--';
      return statusStr;
    },
  },
  {
    ellipsis: true,
    title: '创建时间',
    width: 180,
    dataIndex: 'createTime',
    key: 'createTime',
    customRender: (text) => {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
  {
    ellipsis: true,
    title: '更新时间',
    width: 180,
    dataIndex: 'lastUpdateTime',
    key: 'lastUpdateTime',
    customRender: (text) => {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
  {
    ellipsis: true,
    title: '创建方式',
    width: 110,
    dataIndex: 'createWay',
    key: 'createWay',
    customRender: text => {
      let statusStr = {
        'manual': '手动',
        'automate': '自动',
      }[text] || '--';
      return statusStr;
    },
  },
];

export default {
  name: 'AccountStatement',
  components: {
    xzTable,
    tableHeaderConfiguration,
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        // advancedSearch: true,
        custom: true,
      };
    },
  },
  data () {
    return {
      disabledList: ['prCode', 'unitName', 'reconciliaStart', 'reconciliaState'],
      dataList: [],
      payWayOptions: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '预付款',
          value: 'AC',
        },
        {
          label: '账期付款',
          value: 'AP',
        },
      ],
      billingStatusOptions: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '待开票',
          value: 'wait',
        },
        {
          label: '部分开票',
          value: 'part',
        },
        {
          label: '已开票',
          value: 'already',
        },
      ],
      ticketEntryStatusOptions: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '待入票',
          value: 'wait',
        },
        {
          label: '部分入票',
          value: 'part',
        },
        {
          label: '已入票',
          value: 'already',
        },
      ],
      writeOffStateOptions: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '待核销',
          value: 'wait',
        },
        {
          label: '部分核销',
          value: 'part',
        },
        {
          label: '已核销',
          value: 'already',
        },
      ],
      unitOptions: [
        {
          label: '>',
          value: 2,
        },
        {
          label: '<',
          value: 3,
        },
        {
          label: '=',
          value: 1,
        },
        {
          label: '>=',
          value: 4,
        },
        {
          label: '<=',
          value: 5,
        },
      ],
      executionStatusGroup: [
        {
          label: '全部',
          value: '',
          count: 0,
        },
        {
          label: '待确认',
          value: 'wait',
          count: 0,
        },
        {
          label: '结算中',
          value: 'run',
          count: 0,
        },
        {
          label: '已完成',
          value: 'already',
          count: 0,
        },
        {
          label: '已驳回',
          value: 'reject',
          count: 0,
        },
      ],
      JZForm: {
        reconciliaState: '',
        mark: null,
        payRefundAmount: 0,
        unitName: '',
        paymentWay: null,
        writeOffState: null,
        inTicketState: null,
        opentTicketState: null,
        prCode: '',
        reconciliaStart: '',
        reconciliaEnd: '',
        operateTime: [],
      },
      collectionStatusOptions,
      deliveryStatusOptions,
      changeStatusOptions,
      columnList: [
        ...COMMON_COLUMN,
      ],
      baseLists: [
        ...COMMON_COLUMN,
      ],
      scrollHeight: 600,
      isFullScreen: false,
      total: 0,
      pagination: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  created () {
    if (this.$route.query.status) {
      this.JZForm.reconciliaState = this.$route.query.status;
    }
    this.initPage();
  },
  methods: {
    updateColumnList (columnList) {
      this.columnList = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ];
    },
    handleFullScreen () {
      this.isFullScreen = !this.isFullScreen;
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.getList();
    },
    initPage () {
      this.handleSearch();
      this.getSaleContractCount();
    },
    handleEnsure (info) {
      this.$router.push({
        name: 'DetailAccountStatement',
        query: {
          id: info.id,
          status: info.reconciliaState,
          isWait: '1',
        },
      });
    },
    handleDetail (info) {
      this.$router.push({
        name: 'DetailAccountStatement',
        query: {
          id: info.id,
          status: info.reconciliaState,
        },
      });
    },
    handleSearch () {
      this.pagination.pageNum = 1;
      this.getList();
    },
    getList () {
      let currentParams = {
        ...this.JZForm,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        // reconciliaStart: this.JZForm.operateTime && this.JZForm.operateTime.length ? this.JZForm.operateTime[0] : '',
        // reconciliaEnd: this.JZForm.operateTime && this.JZForm.operateTime.length ? this.JZForm.operateTime[1] : '',
      };
      queryReconciliationList(currentParams).then(({body}) => {
        this.dataList = body.list;
        this.total = body.total || 0;
      });
    },
    getSaleContractCount () {
      queryStateInfo({}).then(({ body }) => {
        this.executionStatusGroup = [
          {
            title: '全部',
            value: '',
            count: body.allNum || 0,
          },
          {
            title: '待确认',
            value: 'wait',
            count: body.waitNum || 0,
          },
          {
            title: '结算中',
            value: 'run',
            count: body.runnNum || 0,
          },
          {
            title: '已完成',
            value: 'already',
            count: body.alreadyNum || 0,
          },
          {
            title: '已驳回',
            value: 'reject',
            count: body.rejectNum || 0,
          },
        ];
      });
    },
    handleReset () {
      this.JZForm = {
        reconciliaState: '',
        mark: null,
        payRefundAmount: 0,
        unitName: '',
        paymentWay: null,
        writeOffState: null,
        inTicketState: null,
        opentTicketState: null,
        prCode: '',
        reconciliaStart: '',
        reconciliaEnd: '',
        operateTime: [],
      };
      this.handleSearch();
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }

  /deep/ .contract-option {
    color: #02a7f0;
    cursor: pointer;
    padding: 0 0.25em;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}
/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
/deep/ .amountInfo .el-form-item__content{
  display: flex;
}
/deep/ .content_block .el-col{
  height: 45px;
}
</style>
